import React, { useState, useEffect, useContext } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import ListGroup from 'react-bootstrap/ListGroup';
import Button from 'react-bootstrap/Button';
import { FaRegTrashAlt } from 'react-icons/fa';
import { ObjModal } from '../../../../contexts';
import AddReferredOut from '../../../Modals/AddReferredOut';

import { styled } from '@mui/material/styles';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import KeyboardArrowRightSharpIcon from '@mui/icons-material/KeyboardArrowRightSharp';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import { monthsShort } from '../../../../common/utils';
import { removeRefsOut } from '../../../../common/api';
import { toast } from 'react-toastify';


const IntroducedTo = ( { aid, uid } ) => {
    const { obj, openModal, closeModal, setModal } = useContext( ObjModal );
    const [ expanded, setExpanded ] = useState( false );

    const trash = async ( roid ) => {
        const removed = await removeRefsOut( aid, uid, roid );
        if ( removed.length ) {
            toast.success( `Your referral out has been deleted`, { theme: 'dark' } );
            // window.location.reload( false );
        }
    };

    const formatDate = ( d ) => {
        if ( d ) {
            const [ yr, mon, dd ] = d.replace( /[T\s].*/, '' ).split( '-' );
            return `${monthsShort[parseInt(mon) - 1]} ${dd}, ${yr}`;
        }
        return '';
    }

    useEffect( () => {
        setExpanded( obj.introduced.length > 0 );
    }, [ obj.introduced ] );

    const handleModal = ( t ) => {
        let shouldOpen = true;

        switch ( t ) {
            case 'referred-to':
                setModal( <AddReferredOut close={closeModal} /> ); 
                break;

            default:
                console.log( 'Unknown modal type: ' + t );
                shouldOpen = false;
        }

        if ( shouldOpen ) {
            openModal();
        }
    }

    const AccordionSummary = styled( ( props ) => (
        <MuiAccordionSummary expandIcon={<KeyboardArrowRightSharpIcon sx={{ fontSize: '0.9rem' }} />} {...props} />
    ) ) ( ( { theme } ) => ( {
        backgroundColor:
          theme.palette.mode === 'dark'
            ? 'rgba(255, 255, 255, .05)'
            : 'rgba(0, 0, 0, .03)',
        flexDirection: 'row-reverse',
        '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
            transform: 'rotate(90deg)',
        },
        '& .MuiAccordionSummary-content': {
            marginLeft: theme.spacing(1),
        },
    } ) );

    return (
        <Container fluid className='p-0'>
            <Accordion expanded={expanded}>
                <AccordionSummary expandIcon={<KeyboardArrowRightSharpIcon onClick={ () => setExpanded( !expanded ) } />}>
                    <Row className='align-items-center w-100'>
                        <Col><Typography>Introduced {obj.details.firstname} To... ({obj.introduced.length})</Typography></Col>
                        <Col xs='auto' className='p-0'>
                            <Button size='sm' variant='outline-primary' onClick={ () => handleModal( 'referred-to' ) }>+ Add</Button>
                        </Col>
                    </Row>
                </AccordionSummary>
                <AccordionDetails style={ { maxHeight: '200px', overflowY: 'scroll' } }>
                    <ListGroup variant='flush'>
                    { obj.introduced.map( ( r, idx ) => (
                        <ListGroup.Item key={r.roid}>
                            <Row className='align-items-center'>
                                <Col xs='auto' className='tf-sidebar-obj-value'>
                                    {r.refType}
                                </Col>
                                <Col>
                                    <Row className='align-items-center'>
                                        <Col xs='auto' className='p-1 ps-3 pb-0'>
                                            <Link to={`/contact/${r.to.cid}`}>{r.to.name}</Link>
                                        </Col>
                                    </Row>
                                    <Row className='align-items-center'>
                                        <Col xs='auto' className='p-1 ps-3 pt-0'>{ formatDate( r.refDate ) }</Col>
                                    </Row>
                                </Col>
                                <Col xs='auto'><FaRegTrashAlt className='tf-sidebar-trash' onClick={ () => trash( r.roid ) } /></Col>
                            </Row>
                        </ListGroup.Item>
                    ) ) }
                    </ListGroup>
                </AccordionDetails>
            </Accordion>
        </Container>
    )
}

const mapProps = ( state ) => ( {
    aid: state.user.aid,
    uid: state.user.email
} );

const mapDispatch = ( dispatch ) => ( {
    // remove: dispatch.lists.removeContact,
} );

export default connect( mapProps, mapDispatch )( IntroducedTo );